/**
 * 1. 全局商用级错误提示横幅 (已有的错误方法)
 */
export function msgError(messageText) {
  msgClear();

  const existingModal = document.getElementById('wl-global-error-mask');
  if (existingModal) existingModal.remove();

  const maskNode = document.createElement('div');
  maskNode.id = 'wl-global-error-mask';
  maskNode.innerHTML = `
    <div class="wl-global-modal-card">
      <div class="wl-modal-icon-circle border-error">
        <span class="wl-modal-icon-txt color-error">!</span>
      </div>
      <div class="wl-modal-body-text">${messageText || '系统突发异常，请稍后再试'}</div>
      <button class="wl-modal-btn-confirm bg-error" id="wl-error-btn-close-trigger">确 定</button>
    </div>
  `;

  injectGlobalModalStyle();
  document.body.appendChild(maskNode);

  const closeBtn = document.getElementById('wl-error-btn-close-trigger');
  if (closeBtn) {
    closeBtn.onclick = () => maskNode.remove();
  }
}

/**
 * 2. 【新增】：全局成功提示横幅
 */
export function msgSuccess(messageText) {
  msgClear();

  const existingModal = document.getElementById('wl-global-success-mask');
  if (existingModal) existingModal.remove();

  const maskNode = document.createElement('div');
  maskNode.id = 'wl-global-success-mask';
  maskNode.innerHTML = `
    <div class="wl-global-modal-card">
      <div class="wl-modal-icon-circle border-success">
        <span class="wl-modal-icon-txt color-success">✓</span>
      </div>
      <div class="wl-modal-body-text">${messageText || '操作成功'}</div>
      <button class="wl-modal-btn-confirm bg-success" id="wl-success-btn-close-trigger">确 定</button>
    </div>
  `;

  injectGlobalModalStyle();
  document.body.appendChild(maskNode);

  const closeBtn = document.getElementById('wl-success-btn-close-trigger');
  if (closeBtn) {
    closeBtn.onclick = () => maskNode.remove();
  }
}

/**
 * 3. 【新增】：请求后台接口等待的 Loading 遮罩
 */
export function msgLoading(messageText) {
  msgClear();

  const maskNode = document.createElement('div');
  maskNode.id = 'wl-global-loading-mask';
  maskNode.innerHTML = `
    <div class="wl-global-loading-card">
      <div class="wl-loading-spinner-css"></div>
      <div class="wl-loading-text-hint">${messageText || '加载中...'}</div>
    </div>
  `;

  injectGlobalModalStyle();
  document.body.appendChild(maskNode);
}

/**
 * 4. 【新增】：清除加载状态的方法
 */
export function msgClear() {
  const existingLoading = document.getElementById('wl-global-loading-mask');
  if (existingLoading) {
    existingLoading.remove();
  }
}

/**
 * 5. 【新增】：确认框提示方法 (对标标准二次确认交互)
 * @param {Object} config { title, content, success: () => {}, cancel: () => {} }
 */
export function msgConfirm(config) {
  const existingModal = document.getElementById('wl-global-confirm-mask');
  if (existingModal) existingModal.remove();

  const maskNode = document.createElement('div');
  maskNode.id = 'wl-global-confirm-mask';
  maskNode.innerHTML = `
    <div class="wl-global-modal-card">
      <h4 class="wl-confirm-header-title">${config.title || '系统提示'}</h4>
      <div class="wl-modal-body-text align-left">${config.content || '您确定要执行此操作吗？'}</div>
      <div class="wl-confirm-footer-btns">
        <button class="btn-confirm-cancel" id="wl-confirm-btn-cancel-trigger">取消</button>
        <button class="btn-confirm-execute" id="wl-confirm-btn-ok-trigger">确定</button>
      </div>
    </div>
  `;

  injectGlobalModalStyle();
  document.body.appendChild(maskNode);

  // 取消事件
  document.getElementById('wl-confirm-btn-cancel-trigger').onclick = () => {
    maskNode.remove();
    if (config.cancel && typeof config.cancel === 'function') config.cancel();
  };

  // 确定事件
  document.getElementById('wl-confirm-btn-ok-trigger').onclick = () => {
    maskNode.remove();
    if (config.success && typeof config.success === 'function') config.success();
  };
}

/**
 * 独立公用：注入多态弹窗的统一 CSS 样式外壳
 */
function injectGlobalModalStyle() {
  const existingStyle = document.getElementById('wl-global-modal-unified-css');
  if (existingStyle) return; // 避免重复注入

  const styleNode = document.createElement('style');
  styleNode.id = 'wl-global-modal-unified-css';
  styleNode.innerHTML = `
    #wl-global-error-mask, #wl-global-success-mask, #wl-global-confirm-mask, #wl-global-loading-mask {
      position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
      background-color: rgba(0, 0, 0, 0.4); display: flex; justify-content: center; align-items: center;
      z-index: 999999; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; animation: wlFadeIn 0.2s ease-out;
    }
    .wl-global-modal-card {
      width: 420px; background-color: #ffffff; border-radius: 8px;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25); padding: 30px;
      display: flex; flex-direction: column; align-items: center;
      animation: wlScaleIn 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.15);
    }
    .wl-modal-icon-circle {
      width: 56px; height: 56px; border-radius: 50%; display: flex; justify-content: center; align-items: center; margin-bottom: 16px; box-sizing: border-box;
    }
    .border-error { border: 3px solid #ef4444; }
    .border-success { border: 3px solid #00c853; }
    
    .wl-modal-icon-txt { font-size: 32px; font-weight: bold; line-height: 1; }
    .color-error { color: #ef4444; }
    .color-success { color: #00c853; }

    .wl-modal-body-text {
      font-size: 15px; color: #333333; font-weight: 500; line-height: 1.5;
      margin-bottom: 24px; word-break: break-all; padding: 0 10px; text-align: center;
    }
    .wl-modal-body-text.align-left { text-align: left; width: 100%; box-sizing: border-box; margin-bottom: 30px;}

    .wl-modal-btn-confirm {
      width: 140px; height: 38px; border: none; border-radius: 6px; color: #ffffff; font-size: 14px; font-weight: 500; cursor: pointer;
    }
    .bg-error { background-color: #ef4444; box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3); }
    .bg-success { background-color: #00c853; box-shadow: 0 4px 12px rgba(0, 200, 83, 0.3); }
    .wl-modal-btn-confirm:hover { opacity: 0.9; }

    /* 二次确认框专属排版 */
    .wl-confirm-header-title { font-size: 16px; color: #333; font-weight: bold; margin: 0 0 16px 0; width: 100%; text-align: left; }
    .wl-confirm-footer-btns { display: flex; justify-content: flex-end; gap: 15px; width: 100%; }
    .wl-confirm-footer-btns button { width: 90px; height: 34px; border: none; border-radius: 4px; font-size: 13px; font-weight: 500; cursor: pointer; }
    .btn-confirm-cancel { background-color: #f1f5f9; color: #64748b; }
    .btn-confirm-cancel:hover { background-color: #e2e8f0; }
    .btn-confirm-execute { background-color: #3b82f6; color: #ffffff; box-shadow: 0 3px 8px rgba(59, 130, 246, 0.25); }
    .btn-confirm-execute:hover { opacity: 0.9; }

    /* 加载框专属排版 */
    .wl-global-loading-card {
      background-color: rgba(255, 255, 255, 0.95); padding: 24px 40px; border-radius: 8px;
      box-shadow: 0 10px 30px rgba(0,0,0,0.15); display: flex; flex-direction: column; align-items: center; gap: 12px;
    }
    .wl-loading-spinner-css {
      width: 32px; height: 32px; border: 3px solid #f3f3f3; border-top: 3px solid #3b82f6; border-radius: 50%; animation: wlSpin 0.8s linear infinite;
    }
    .wl-loading-text-hint { font-size: 14px; color: #555555; font-weight: 500; }

    @keyframes wlFadeIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes wlScaleIn { from { transform: scale(0.8); opacity: 0; } to { transform: scale(1); opacity: 1; } }
    @keyframes wlSpin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
  `;
  document.body.appendChild(styleNode);
}
